import { deepFreezeDescendants } from "../../utils/deepFreeze.js";
import { initializeFields } from "./createStore.initializeFields.js";
function createStore(config) {
  const { initialValues, fields, errors, formStatus } = initializeFields(config);
  return deepFreezeDescendants({
    id: config.id,
    initialValues,
    values: structuredClone(initialValues),
    fields,
    errors,
    meta: { disabled: false, submitting: false, validating: false, status: formStatus }
  });
}
export {
  createStore
};
//# sourceMappingURL=createStore.js.map
